export default __webpack_public_path__ + "static/cyber-threat-intelligence (1)-1df1b8afac64e7a0d8f732a6cf2d42d0.png";